<script setup>
import {ref} from "vue"
import PrinterSelect from "../layout/printer-select.vue";
import {useDocs} from "@/lib/useDocs";

const {printDoc} = useDocs();

const props = defineProps({
  url: {
    required: true,
    type: Object
  },
  single: Boolean
})

const printer = ref()
const save_printer = ref(false)
const printer_select = ref()

const print = () => {
  printDoc(printer.value, 'LabelPackage', props.url, 1, false, {
    printer_type: 'printers.package',
    save_printer: save_printer.value,
  }).then(() => {
    if (save_printer.value)
      printer_select.value.loadSettings()
  })
}
</script>

<template>
  <div>
    <b-input-group>
      <printer-select v-model="printer" type="LabelPackage" setting="printers.package"
                      ref="printer_select"/>
      <b-input-group-append>
        <b-btn size="sm" variant="outline-secondary" @click="print">
          <font-awesome-icon class="px-2" :icon="['fas', 'print']"/>
        </b-btn>
      </b-input-group-append>
    </b-input-group>
    <div class="mt-2">
      <b-check switch v-model="save_printer">Save as default printer</b-check>
    </div>
  </div>
</template>

<style scoped>

</style>